var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 14.1625V3.25H3.25V0.25H11.1625V6.25H14.1625V14.1625H7.95625V10.9563H6.45625V14.1625H0.25ZM1.95625 12.4563H3.45625V10.9563H1.95625V12.4563ZM1.95625 9.45625H3.45625V7.95625H1.95625V9.45625ZM1.95625 6.45625H3.45625V4.95625H1.95625V6.45625ZM4.95625 9.45625H6.45625V7.95625H4.95625V9.45625ZM4.95625 6.45625H6.45625V4.95625H4.95625V6.45625ZM4.95625 3.45625H6.45625V1.95625H4.95625V3.45625ZM7.95625 9.45625H9.45625V7.95625H7.95625V9.45625ZM7.95625 6.45625H9.45625V4.95625H7.95625V6.45625ZM7.95625 3.45625H9.45625V1.95625H7.95625V3.45625ZM10.9563 12.4563H12.4563V10.9563H10.9563V12.4563ZM10.9563 9.45625H12.4563V7.95625H10.9563V9.45625Z",
    fill: "#909092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/BuildingIcon.bb46dc52a9d3f84bd995652b65fccfa8.svg";
export { ForwardRef as ReactComponent };